import { produce } from 'immer'

export default (reducerActions) => {
  return produce((draftState, action, ...args) => {
    const actionFunc = reducerActions[action.type]

    actionFunc && actionFunc(draftState, action, ...args)
  })
}
